import { render, staticRenderFns } from "./rahatalo.vue?vue&type=template&id=74b7b553&"
import script from "./rahatalo.vue?vue&type=script&lang=js&"
export * from "./rahatalo.vue?vue&type=script&lang=js&"
import style0 from "./rahatalo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports